<template>
  <div class="tw-relative tw-flex tw-items-center tw-justify-center" :class="root" slot="center" v-on="$listeners">
    <button
        class="tw-p-0 tw-z-10 tw-relative tw-text-infinity-play-button-icon tw-rounded-full tw-bg-infinity-play-button-background tw-border-0" :class="button">
       <font-awesome-icon :icon="playing ? 'pause' : 'play'" :class="!playing && 'tw-left-px tw-relative'"></font-awesome-icon>
    </button>
    <div
        :class="quarter"
        class="tw-absolute tw-z-0 tw-top-0 tw-right-0 tw-rounded-tr-3xl tw-bg-infinity-play-button-background tw-opacity-50"
        style="border-top-left-radius: 3px; border-bottom-right-radius: 3px;" />
    <div
        :class="quarter"
        class="tw-absolute tw-z-0 tw-bottom-0 tw-left-0 tw-rounded-bl-3xl tw-bg-infinity-play-button-background tw-opacity-50"
        style="border-top-left-radius: 3px; border-bottom-right-radius: 3px;" />
  </div>
</template>
<script>
export default {
  props: {
    playing: Boolean,
    size: {
      type: String,
      validator: (size) => ['small', 'medium'].includes(size),
      default: 'medium'
    },
  },
  computed: {
    root() {
      const classes = {
        medium: 'tw-w-11.5 tw-h-11.5',
        small: 'tw-w-7.5 tw-h-7.5'
      }

      return classes[this.size]
    },
    button() {
      const classes = {
        medium: 'tw-w-10 tw-h-10 tw-text-base',
        small: 'tw-w-6.5 tw-h-6.5 tw-text-xs'
      }

      return classes[this.size]
    },
    quarter() {
      const classes = {
        medium: 'tw-w-6 tw-h-6',
        small: 'tw-w-4 tw-h-4'
      }

      return classes[this.size]
    }
  }
};
</script>
